module.exports = "pegasus_template/assets/tech/birthday/100.png";